"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Code_styles_1 = __importDefault(require("./Code.styles"));
function Code(_a) {
    var children = _a.children, themeOverride = _a.themeOverride, _b = _a.block, block = _b === void 0 ? false : _b, className = _a.className, color = _a.color, others = __rest(_a, ["children", "themeOverride", "block", "className", "color"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var themeColor = color || (theme.colorScheme === 'dark' ? 'dark' : 'gray');
    var classes = Code_styles_1.default({ color: themeColor, theme: theme_1.useMantineTheme(themeOverride) });
    if (block) {
        return (react_1.default.createElement("pre", __assign({ className: clsx_1.default(classes.code, classes.pre, className) }, others), children));
    }
    return (react_1.default.createElement("code", __assign({ className: clsx_1.default(classes.code, className) }, others), children));
}
exports.Code = Code;
Code.displayName = '@mantine/core/Code';
